import React, { Fragment, type PropsWithChildren } from "react";

import styles from "./styles";
import position from "../../styles/position";

const Splitter = (props: PropsWithChildren) => {
    return <div style={position.relativeFill}>
        <table cellPadding={0} cellSpacing={0} style={styles.table}>
            <tbody>
                <tr>
                    <td style={styles.header}>
                        {React.Children.map(props.children, (child, i) => {
                            if (i != 0) {
                                return <Fragment />
                            }
                            return <Fragment key={i}>{child}</Fragment>;
                        })}
                    </td>
                </tr>
                <tr>
                    <td style={styles.contentWrapper}>
                        <div style={styles.content}>
                            {React.Children.map(props.children, (child, i) => {
                                if (i == 0) {
                                    return <Fragment />
                                }
                                return <Fragment key={i}>{child}</Fragment>;
                            })}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
}

export default Splitter;